import React from 'react'
import { Global, css } from '@emotion/react'

export const ModalStyle = () => (
  <Global
    styles={css`
      .mantine-Modal-modal {
        padding: 0;
      }
      .mantine-Modal-header {
        padding: 13px 20px;
        margin-bottom: 0;
      }
      .mantine-Modal-title {
        font-size: 18px;
        font-weight: 500;
      }
      .mantine-Modal-body {
        padding: 0 20px 20px;
        border-top: 1px solid #ced4da;
      }
    `}
  />
)

export const PopoverStyle = () => (
  <Global
    styles={css`
      .mantine-Popover-dropdown {
        padding: 0 !important;
      }
    `}
  />
)
